import { useTheme } from '@mui/material'
import { Html } from '@react-three/drei'
import { HtmlProps } from '@react-three/drei/web/Html'
import { Vector3 } from '@react-three/fiber'

interface Props {
  label: string
  position: Vector3
  style?: Record<string, string>
  highlighted?: boolean
  onClick?: () => void
  visible?: boolean
  htmlProps?: HtmlProps
}

const Label = ({
  label,
  position,
  style,
  onClick,
  highlighted = false,
  visible = true,
  htmlProps = {},
}: Props) => {
  const theme = useTheme()

  if (!visible) return <></>

  return (
    <Html
      position={position}
      // zIndex is not really working on Html elements, hence this is a little
      // hack https://github.com/pmndrs/drei/issues/702 for this to work the
      // scene must be moved though. As it will only recalculate once moved
      zIndexRange={highlighted ? [1, 1] : [0, 0]}
      {...htmlProps}
      center
    >
      <div
        onClick={() => onClick && onClick()}
        style={{
          fontSize: 12,
          borderRadius: 2,
          padding: 1,
          color: theme.palette.grey[100],
          // @ts-ignore
          backgroundColor: theme.palette.primary.main,
          cursor: onClick ? 'pointer' : 'default',
          ...(highlighted
            ? {
                backgroundColor: theme.scenePalette.highlight,
                color: theme.palette.text.primary,
              }
            : {}),
          ...style,
        }}
      >
        {label}
      </div>
    </Html>
  )
}

export default Label
